import React, { Component } from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import FormikInputField from '~/components/formikInputField/formikInputField';

export const getConsolidatedLotSchedulesQuery = gql`
  query transferSchedules($breweryId: Int!) {
    transferSchedules(breweryId: $breweryId, isConsolidated: true) {
      id
      name
    }
  }
`;

export class ConsolidatedLotScheduleDropdown extends Component {
  render() {
    const { name, brewery, className, value } = this.props;
    return (
      <Query
        query={getConsolidatedLotSchedulesQuery}
        variables={{ breweryId: brewery.id }}
        fetchPolicy={'cache-and-network'}
      >
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <p className="ma0">Getting schedules</p>;
          }

          if (error) {
            return <p className="ma0">Error getting schedules</p>;
          }

          return (
            <FormikInputField type="select" name={name} className={className} value={value}>
              <option />
              {data.transferSchedules.map(t => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </FormikInputField>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}
export default connect(mapStateToProps)(ConsolidatedLotScheduleDropdown);



// WEBPACK FOOTER //
// ./src/containers/consolidatedLotScheduleDropdown/consolidatedLotScheduleDropdown.jsx